import { isEmpty, isEqual, xorWith } from 'lodash';

import { accessIconsMap } from '../../icons/AccessIcons';
import { activityIconsMap } from '../../icons/ActivityIcons';
import { FilterOption } from 'components/search/Filters/SearchFilter';
import { SearchFilter } from 'contexts/SearchHelpers';
import PoiTypeIcon from 'components/icons/PoiTypeIcon';

export const isArrayEqual = (x, y) => isEmpty(xorWith(x, y, isEqual));

export const twoCols = ['poi-type', 'aktivnosti'];

export function IconLabel({ icon, label }) {
    return (
        <div className="flex items-center space-x-1">
            <span className="text-2xl">{icon}</span>
            <span>{label}</span>
        </div>
    );
}

export function PoiTypeOptionLabel({ slug, name }) {
    return <IconLabel icon={<PoiTypeIcon slug={slug} />} label={name} />;
}

export function AccessOptionLabel({ value }) {
    const Icon = accessIconsMap[value];
    return <IconLabel icon={<Icon />} label={value} />;
}

export function ActivityOptionLabel({ value }) {
    const Icon = activityIconsMap[value];
    return <IconLabel icon={<Icon />} label={value} />;
}

export const getOptionLabel = (filter, option) => {
    switch (filter.slug) {
        case 'poi-type':
            return <PoiTypeOptionLabel slug={option.slug} name={option.name} />;
        case 'dostopnost':
            return <AccessOptionLabel value={option.value} />;
        case 'aktivnosti':
            return <ActivityOptionLabel value={option.value} />;
        default:
            return option.label ?? option.value;
    }
};

export const getOptionValue = (option) => `${option.slug ?? option.value}`;

export const generateOptions = (filter: SearchFilter): FilterOption[] =>
    filter.options.map((option) => ({
        slug: filter.slug,
        value: getOptionValue(option),
        label: getOptionLabel(filter, option)
    }));

export const generateContextFilters = (options) =>
    options.map((option) => ({
        slug: option.slug,
        value: option.value
    }));
